import { Flex, message, Upload, Image } from 'antd';
import React, { useState } from 'react';
import { LoadingOutlined, PlusOutlined, DeleteOutlined, UploadOutlined, EditOutlined } from '@ant-design/icons';
import config from "../../api/config";
import EntityApi from "../../api/EntityApi";

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('Допустимые форматы JPEG и PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
        message.error('Максимальный размер файла 10MB!');
    }
    return isJpgOrPng && isLt2M;
};

const AvatarUser = ({id, url}) => {

    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            setLoading(false);
            setImageUrl(info.file.response.url);

            let user = JSON.parse(localStorage.getItem('user'));
            if (user.id === id) {
                user.avatar = id + '.jpg';
                localStorage.setItem('user', JSON.stringify(user));
            }

            /*getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
                setImageUrl(url);
            });*/
        }
    };
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Загрузить
            </div>
        </button>
    );

    const deleteAvatar = () => {
        if (id > 0) {
            EntityApi.delete('private/user-avatar', id);
            setImageUrl(null);
            let user = JSON.parse(localStorage.getItem('user'));
            if (user.id === id) {
                user.avatar = '';
                localStorage.setItem('user', JSON.stringify(user));
            }
        }
    }

    React.useEffect(() => {
        console.log(url);
        if (url) {
            setImageUrl(url);
        } else {
            setImageUrl(null);
        }
    }, [url])

    return <div className={'relative'} style={{top: '0', left: '0', width: '100px', height: '100px'}}>
        {
            !imageUrl && <Upload
                name="avatar"
                listType="picture-circle"
                className="avatar-uploader"
                showUploadList={false}
                headers={{
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }}
                action={config.host + "/api/private/user-avatar/" + id}
                beforeUpload={beforeUpload}
                onChange={handleChange}
            >
                {uploadButton}
            </Upload>
        }
        {
            imageUrl && <Upload
                name="avatar"
                showUploadList={false}
                headers={{
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }}
                action={config.host + "/api/private/user-avatar/" + id}
                beforeUpload={beforeUpload}
                onChange={handleChange}
            >
                <button className={'absolute'} style={{top: '-10px', left: '-10px'}}><EditOutlined /></button>
            </Upload>
        }
        {
            imageUrl && <div className={'absolute'} style={{top: '0', left: '0', width: '100px', height: '100px'}}>
                <Image
                    className="rounded-full"
                    src={imageUrl}
                    preview={{
                        mask: <span></span>,
                        maskClassName: 'hover-user-avatar',
                        src: imageUrl.replace("_100", "_orig"),
                    }}
                />
            </div>
        }
        {
            imageUrl && <button className={'absolute'} style={{top: '-10px', right: '-10px'}} onClick={deleteAvatar}><DeleteOutlined/></button>
        }
    </div>

}

export default AvatarUser;
